import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=b220b264&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=b220b264&prod&scoped=true&lang=css"
import style1 from "./OnBoarding.vue?vue&type=style&index=1&id=b220b264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b220b264",
  null
  
)

export default component.exports